module.exports = __webpack_public_path__ + "static/media/3.d1a93cc2.jpg";